import { verifyContainsCreditDebitCardTransactions } from "./verifyAccountProducts";
import { authData } from "./index";

interface ActiveModules {
    id: number;
    route_name: string;
    icon_name: string;
    description: string;
    main_menu: number;
    is_topic: number;
    is_submenu: number;
    id_topic_module: number;
    status: number;
}

const getActiveModules = (): ActiveModules[] => {
    const { access_profile_modules = [] } = authData.get();
    

    const result = access_profile_modules
        .filter((module: any) => {
            const {
                description = '',
                main_menu = 0,
                is_topic = 0,
                route_name = '',
                status = 1
            } = module;

            // Regras de bloqueio
            // É possível adicionar abaixo qualquer menu que se deseje desativar temporariamente.
            if (status === 0) {
                return false;
            }

            return true;
        });

    return result;
};

export default getActiveModules;
